module.exports = __webpack_public_path__ + "media/images/logos/email-header-345009fdcb878653b450117a48191bb6.jpg";